export default "__VITE_PUBLIC_ASSET__2673be4a__"